import classnames from 'classnames'
import PropTypes from 'prop-types'

import CloseIcon from '../svg_icons/icons/CloseIcon'

import './closer.scss'

const Closer = ({alt, className, closer, onClick, 'data-testid': dataTestId, ...otherProps}) => (
  <button
    aria-label={alt}
    className={classnames('core closer', className)}
    data-testid={dataTestId}
    onClick={closer || onClick}
    type='button'>
    <CloseIcon {...otherProps} />
  </button>
)

Closer.defaultProps = {alt: 'Close modal', 'data-testid': 'closer'}

Closer.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  closer: PropTypes.func,
  'data-testid': PropTypes.string,
  onClick: PropTypes.func
}

export default Closer
